export default __webpack_public_path__ + "static/media/j13.a5029ad2.jpg";